import dayjs from 'dayjs';

/**
 * 日付フォーマットの列挙型
 */
export enum DateFormat {
  YYYYMMDD = 'YYYY/MM/DD',
  YYYYMMDD_HYPHEN = 'YYYY-MM-DD',
  HHMMSS = 'HH:mm:ss',
  YYYYMMDDHHMMSS = 'YYYY/MM/DD HH:mm:ss',
}

/**
 * 日付を文字列に変換する。
 * @param date
 * @param format
 */
export const formatDate = (date: dayjs.Dayjs, format: DateFormat): string => {
  return dayjs(date).format(format);
};
